module.exports = __webpack_public_path__ + "img/logo-aldo-solar.2cd293b0.svg";